var React = require('react');

function IcArrowTilted (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"m9 6 1-1h9v9l-1 1-1 1V8.414L6.707 18.707l-1.414-1.414L15.586 7H8l1-1Z","fill":"currentColor"}));
}

IcArrowTilted.defaultProps = {"fill":"none","viewBox":"0 0 24 24"};

module.exports = IcArrowTilted;

IcArrowTilted.default = IcArrowTilted;
